import React, { useContext } from "react";

import Modal from "@stadium/ui/src/components/ModalNew";

import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  ModalFooter,
} from "@stadium/ui/src/components/ModalNew/utils";

import Multimedia from "@sharedComponents/multimedia";
import { InternalButton } from "@components/shared/buttons";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

const noBundlesImage = require("@images/character-working.png");

import styles from "./main.module.scss";

const AddOndemandModal = ({ closeModal, onClick, onClose, data }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  // TODO: remove data.onClick and data.onClose once feature flag is enabled
  const handleConfirm = onClick ?? data?.onClick;
  const handleCancel = onClose ?? data?.onClose;

  const handleClose = () => {
    handleCancel?.();
    closeModal();
  };

  return (
    <Modal closeModal={handleClose} newModal mobileBottomDrawer>
      <ModalDialog>
        <ModalContent className={styles.onDemandModal}>
          <ModalHeader>
            On-demand items will ship separately. Do you want to continue?
            <CloseButton onClick={handleClose} />
          </ModalHeader>
          <ModalBody className={styles.modalBody}>
            <div className={styles.characterImg}>
              <Multimedia src={noBundlesImage} type="image" alt="No results found" />
            </div>
            <p>
              If you choose to add on-demand items, they'll ship separately when items are ready.{" "}
            </p>
            <p>*All box customizations will only be available for kitted items.</p>
          </ModalBody>
          <ModalFooter>
            <InternalButton
              className={styles.footerBtn}
              styleType="primary-outline"
              onClick={() => {
                handleConfirm?.();
                closeModal();
              }}
            >
              {isMobileDevice ? "Add items" : "Add on-demand anyway"}
            </InternalButton>
            <InternalButton className={styles.footerBtn} onClick={handleClose}>
              Don't Add
            </InternalButton>
          </ModalFooter>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};

export default AddOndemandModal;
